const GetValueDashboardForIndividualTypes = {
	/** ****************************** SECTION WISE FETCH *********************** */
	GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_START: 'get_value_dashboard_for_individual_start',
	GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_SUCCESS: 'get_value_dashboard_for_individual_success',
	GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_FAILURE: 'get_value_dashboard_for_individual_failure',
	GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_RESPONSE_CHANGED: 'get_value_dashboard_for_individual_response_changed',
	GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_RESPONSE_REST_START: 'get_value_dashboard_for_individual_response_rest_start',
};

export default GetValueDashboardForIndividualTypes;
